
import Vue from 'vue'
import router from './router'
import App from './App.vue'
import store from './store'
import delDialog from '@/components/delDialog'
import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import './plugins/acl'
import vuetify from './plugins/vuetify'
import '@/assets/css/common.scss'
import { getCookie, delCookie, setCookie ,IsIPMode} from '@/utils/cookie';
import { getSmsModel, getEmailModel } from '@/utils/index';
import checkPassword from '@/utils/checkPass';
import checkNotLoginPassword from '@/utils/checkPwd';
import { passwordEncryption } from '@/utils/rsa';
import { serverUrlFun,setWebNav } from '@/utils/serverUrl';
import { userEditPwdFun } from '@/utils/userEditPwd';
import VueCropper from 'vue-cropper'
import httpStatusCode from "@/utils/httpStatusCode";
import i18n from '@/utils/i18n';
import 'moment/locale/zh-cn'
import { navigationDrawerH } from '@/@core/utils/common.js'

Vue.component('del-dialog', delDialog)
Vue.config.productionTip = false
Vue.prototype.$navigationDrawerH = navigationDrawerH

Vue.use(VueCropper)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if(IsIPMode()) {

    if(to.fullPath.indexOf('/404')>-1  || to.fullPath.indexOf('/yxl-bind') > -1 || to.fullPath.indexOf('/yxl-bind-sucess') > -1
      || to.fullPath.indexOf('/501') > -1 || to.fullPath.indexOf('/error') > -1){
       next()
    }else if (to.fullPath.indexOf("bindToken") > -1 || to.fullPath.indexOf("authToken") > -1) {
      if(!to.query.appKey){
        router.push({
          path: '/404'
        })
      }else{
        next()
      }

   }else {
      if(from.query.appKey){
        if (!to.query.appKey) {
          //准备一个跳转的query对象
          let query = to.query
          query.appKey = from.query.appKey
          next({
            path: to.path,
            query: query
          })
        } else {
          next()
        }
      }else{
        // if(!from.query.appKey && !to.query.appKey){
        //   router.push({
        //     path: '/404'
        //   })
        //
        // }else{
          next()
        // }


      }
  }

  }else{
    if (to.path == '/') {
        if(getCookie("userInfo")) {
          router.push({
            path: '/adhibition'
          })
        } else if (to.fullPath.indexOf("bindToken") > -1 || to.fullPath.indexOf("authToken") > -1 || to.fullPath.indexOf("yxl-bind") > -1) {
          next()
        } else {
          router.push({
            path: '/login'
          })
        }
    } else {
      next()
    }
  }
})

Vue.prototype.$cookieStore = {
  setCookie,
  getCookie,
  delCookie
}
Vue.prototype.$getSmsModel = getSmsModel
Vue.prototype.$getEmailModel = getEmailModel
Vue.prototype.$checkPassword = checkPassword
Vue.prototype.$checkNotLoginPassword = checkNotLoginPassword
Vue.prototype.$passwordEncryption = passwordEncryption
Vue.prototype.$serverUrlFun = serverUrlFun
Vue.prototype.$userEditPwdFun = userEditPwdFun
Vue.prototype.$GLOBA = httpStatusCode

let $vue = new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App),
  data: {
      eventHub: new Vue()
  }
}).$mount('#app')
export default $vue

